import {actions} from "./Reducer"
import { proposalById } from "./Selectors"


export const getMyArtisanPrivateInquiryAction = (payload) => ({
    type : actions.GET_MY_ARTISAN_PRIVATE_INQUIREY,
    payload 
})

export const getMyArtisanPrivateInquirySuccessAction = (privateInquiry) => ({
    type : actions.GET_MY_ARTISAN_PRIVATE_INQUIREY_SUCCESS , 
    payload : privateInquiry
})


export const getMyArtisanPrivateInquiriesAction = (body) => ({
    type:actions.GET_MY_ARTISAN_PRIVATE_INQUIRIES,
    payload: body
})

export const getMyArtisanPrivateInquiriesSuccessAction = (inquiries) => ({
    type: actions.GET_MY_ARTISAN_PRIVATE_INQUIRIES_SUCCESS,
    payload: inquiries
})


export const addProposalByArtisanAction = (body, trusted) => ({
    type: actions.ADD_PROSPOSAL_BY_ARTISAN,
    payload: body,
    trusted
})

export const addProposalByArtisanSuccessAction = (proposal) => ({
    type: actions.ADD_PROSPOSAL_BY_ARTISAN_SUCCESS,
    payload: proposal
})

export const setMyArtisanPrivateInquiryIsLoading = (isLoading) => ({
    type : actions.MY_ARTISAN_PRIVATE_INQUIREY_IS_LOADING,
    payload : isLoading
})

export const setMyArtisanPrivateInquiryCountAction = (value) => ({
    type: actions.SET_MY_ARTISAN_PRIVATE_INQUIRIES_COUNT,
    payload: value
})

export const getMyArtisanProposalsAction = (body) => ({
    type:actions.GET_MY_ARTISAN_PROPOSALS,
    payload: body
})

export const getMyArtisanProposalsSucessAction = (proposals) => ({
    type: actions.GET_MY_ARTISAN_PROPOSALS_SUCCESS,
    payload: proposals
})

export const getMyArtisanProposalAction = (body) => ({
    type:actions.GET_MY_ARTISAN_PROPOSAL,
    payload: body
})

export const getMyArtisanProposalSuccessAction = (proposal) => ({
    type: actions.GET_MY_ARTISAN_PROPOSAL_SUCCESS,
    payload: proposal
})

export const editProposalByArtisanAction = (body, trusted) => ({
    type:actions.EDIT_PROPOSAL_BY_ARTISAN,
    payload: body,
    trusted
})

export const editProposalByArtisanSuccessAction = (proposal) => ({
    type:actions.EDIT_PROPOSAL_BY_ARTISAN_SUCCESS,
    payload: proposal
})